// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Trigger lives in the left rail (below the built-in nodes); the panel opens
   into the strip to the right of the rail. */
.kTI5OAtstn4Q9NtOUozk {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  pointer-events: none;
}

.kTI5OAtstn4Q9NtOUozk > * {
  pointer-events: auto;
}

.MtLwg2F74xR3_4GDa4cl {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  flex-shrink: 0;
}

.r44iYmXrfdxAevmqYlGw {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  background-color: #1e1f23;
  color: #fbfcf6;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
}

.RMG1UoovsT9Hujjd7SyY {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.r44iYmXrfdxAevmqYlGw:hover {
  background-color: #2c2d32;
}

.bU_LN6EPTdkYMi2q5Jnb {
  border-color: rgba(251, 170, 105, 0.85);
  color: #fbaa69;
}

.mhiVFMLO15UvrrBIu4zT {
  font-size: 1.25em;
}

.BQkh83G8QCUrG9JK1CW1 {
  font-size: 10px;
  opacity: 0.85;
}


.CMkBdKOe2ASsyAfVs5W9 {
  color: inherit;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.6px;
  line-height: 1;
  text-transform: uppercase;
}

.gd_UVUEmaKGTebJnIErP {
  border-radius: 8px;
  background: rgba(251, 170, 105, 0.25);
  color: #fbfcf6;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.bU_LN6EPTdkYMi2q5Jnb .gd_UVUEmaKGTebJnIErP {
  background-color: rgba(251, 170, 105, 0.35);
}

/* Absolutely positioned against #tools-palette-dock (the only positioned
   ancestor) so the panel opens beside the built-in rail without widening it. */
.VecrEQNkVACOMMokqR8V {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 10px;
  width: min(380px, calc(100vw - 120px));
  min-height: 0;
  max-height: calc(100vh - 170px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  background-color: #1e1f23;
  box-shadow: 6px 10px 28px rgba(0, 0, 0, 0.45);
  color: #fbfcf6;
}

.E9EVfRTD2FzUNY8_0Kpk {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 34px;
  padding: 0 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.PSLIuo7xg1ErblGoXN9L {
  color: rgba(255, 255, 255, 0.55);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1.2;
  text-align: left;
  text-transform: uppercase;
}

/* Sort toggle pinned to the right of the "Installed datasets" section header. */
.wXae3hSixEoqd18VK8lF {
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(251, 252, 246, 0.7);
  padding: 3px 9px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.wXae3hSixEoqd18VK8lF:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
  color: rgba(251, 252, 246, 0.92);
}

.ZxzfBPoYCRDCTHRrEUYm {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
  scrollbar-width: thin;
}

.ZxzfBPoYCRDCTHRrEUYm::-webkit-scrollbar {
  width: 5px;
}

.ZxzfBPoYCRDCTHRrEUYm::-webkit-scrollbar-track {
  background: transparent;
}

.ZxzfBPoYCRDCTHRrEUYm::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
}

.ZxzfBPoYCRDCTHRrEUYm:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.22);
}

.WhODDk5jl3blNyxm3rcj {
  width: 30px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 4px;
  background: transparent;
  color: rgba(251, 252, 246, 0.92);
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
}

.WhODDk5jl3blNyxm3rcj:hover {
  background: rgba(255, 255, 255, 0.08);
}

.vxmF2fNK525mqJrGQNB8 {
  border-radius: 4px;
  color: rgba(251, 252, 246, 0.62);
  padding: 10px 6px;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
}

.FK2UXQr1e7uSfjEWzlxZ {
  margin-bottom: 8px;
  border: 1px dashed rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  color: rgba(251, 252, 246, 0.62);
  padding: 16px 10px;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
}

.tBNIbQnnTvTfSALz_wCw {
  flex-shrink: 0;
  padding: 8px 10px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background-color: #1e1f23;
  box-shadow: 0 -6px 12px rgba(0, 0, 0, 0.18);
}

.XN7SmUuhASiPifPg7w2P {
  width: 100%;
  box-sizing: border-box;
  min-height: 32px;
  border: none;
  border-radius: 4px;
  background-color: #fbaa69;
  color: #1e1f23;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.XN7SmUuhASiPifPg7w2P:hover {
  background-color: #fb9a4f;
}

.XN7SmUuhASiPifPg7w2P:focus-visible {
  outline: 2px solid rgba(251, 170, 105, 0.85);
  outline-offset: 2px;
}

/* Transient highlight applied to a row revealed from a node's DATASET chip. */
.fWYXPMMOZNTuE3YgnsO3 {
  animation: boktGfwINNsR0hUJnRwN 1.4s ease-out;
  border-radius: 6px;
}

@keyframes boktGfwINNsR0hUJnRwN {
  0% {
    box-shadow: 0 0 0 2px rgba(47, 143, 74, 0.9);
    background-color: rgba(47, 143, 74, 0.22);
  }
  100% {
    box-shadow: 0 0 0 2px rgba(47, 143, 74, 0);
    background-color: transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/datasetPalette/DatasetsPaletteDropdown.module.css"],"names":[],"mappings":"AAAA;6CAC6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;;AAGA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sDAAsD;EACtD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,+CAA+C;EAC/C,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,6CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE;IACE,4CAA4C;IAC5C,yCAAyC;EAC3C;EACA;IACE,0CAA0C;IAC1C,6BAA6B;EAC/B;AACF","sourcesContent":["/* Trigger lives in the left rail (below the built-in nodes); the panel opens\n   into the strip to the right of the rail. */\n.root {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n.root > * {\n  pointer-events: auto;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.trigger {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 5px;\n  background-color: #1e1f23;\n  color: #fbfcf6;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n}\n\n.triggerTop {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.trigger:hover {\n  background-color: #2c2d32;\n}\n\n.triggerOpen {\n  border-color: rgba(251, 170, 105, 0.85);\n  color: #fbaa69;\n}\n\n.triggerIcon {\n  font-size: 1.25em;\n}\n\n.triggerChevron {\n  font-size: 10px;\n  opacity: 0.85;\n}\n\n\n.triggerLabel {\n  color: inherit;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.triggerCount {\n  border-radius: 8px;\n  background: rgba(251, 170, 105, 0.25);\n  color: #fbfcf6;\n  padding: 1px 6px;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.triggerOpen .triggerCount {\n  background-color: rgba(251, 170, 105, 0.35);\n}\n\n/* Absolutely positioned against #tools-palette-dock (the only positioned\n   ancestor) so the panel opens beside the built-in rail without widening it. */\n.panel {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  margin-left: 10px;\n  width: min(380px, calc(100vw - 120px));\n  min-height: 0;\n  max-height: calc(100vh - 170px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 5px;\n  background-color: #1e1f23;\n  box-shadow: 6px 10px 28px rgba(0, 0, 0, 0.45);\n  color: #fbfcf6;\n}\n\n.panelHeader {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 34px;\n  padding: 0 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.title {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1.2;\n  text-align: left;\n  text-transform: uppercase;\n}\n\n/* Sort toggle pinned to the right of the \"Installed datasets\" section header. */\n.sortToggle {\n  flex-shrink: 0;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(251, 252, 246, 0.7);\n  padding: 3px 9px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.sortToggle:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: rgba(251, 252, 246, 0.92);\n}\n\n.scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;\n  scrollbar-width: thin;\n}\n\n.scroll::-webkit-scrollbar {\n  width: 5px;\n}\n\n.scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.downloadButton {\n  width: 30px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 4px;\n  background: transparent;\n  color: rgba(251, 252, 246, 0.92);\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.downloadButton:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.sectionEmpty {\n  border-radius: 4px;\n  color: rgba(251, 252, 246, 0.62);\n  padding: 10px 6px;\n  font-size: 11px;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.empty {\n  margin-bottom: 8px;\n  border: 1px dashed rgba(255, 255, 255, 0.16);\n  border-radius: 4px;\n  color: rgba(251, 252, 246, 0.62);\n  padding: 16px 10px;\n  font-size: 11px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.footer {\n  flex-shrink: 0;\n  padding: 8px 10px 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background-color: #1e1f23;\n  box-shadow: 0 -6px 12px rgba(0, 0, 0, 0.18);\n}\n\n.catalogButton {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 32px;\n  border: none;\n  border-radius: 4px;\n  background-color: #fbaa69;\n  color: #1e1f23;\n  padding: 8px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.catalogButton:hover {\n  background-color: #fb9a4f;\n}\n\n.catalogButton:focus-visible {\n  outline: 2px solid rgba(251, 170, 105, 0.85);\n  outline-offset: 2px;\n}\n\n/* Transient highlight applied to a row revealed from a node's DATASET chip. */\n.revealPulse {\n  animation: datasetRevealPulse 1.4s ease-out;\n  border-radius: 6px;\n}\n\n@keyframes datasetRevealPulse {\n  0% {\n    box-shadow: 0 0 0 2px rgba(47, 143, 74, 0.9);\n    background-color: rgba(47, 143, 74, 0.22);\n  }\n  100% {\n    box-shadow: 0 0 0 2px rgba(47, 143, 74, 0);\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `kTI5OAtstn4Q9NtOUozk`,
	"column": `MtLwg2F74xR3_4GDa4cl`,
	"trigger": `r44iYmXrfdxAevmqYlGw`,
	"triggerTop": `RMG1UoovsT9Hujjd7SyY`,
	"triggerOpen": `bU_LN6EPTdkYMi2q5Jnb`,
	"triggerIcon": `mhiVFMLO15UvrrBIu4zT`,
	"triggerChevron": `BQkh83G8QCUrG9JK1CW1`,
	"triggerLabel": `CMkBdKOe2ASsyAfVs5W9`,
	"triggerCount": `gd_UVUEmaKGTebJnIErP`,
	"panel": `VecrEQNkVACOMMokqR8V`,
	"panelHeader": `E9EVfRTD2FzUNY8_0Kpk`,
	"title": `PSLIuo7xg1ErblGoXN9L`,
	"sortToggle": `wXae3hSixEoqd18VK8lF`,
	"scroll": `ZxzfBPoYCRDCTHRrEUYm`,
	"downloadButton": `WhODDk5jl3blNyxm3rcj`,
	"sectionEmpty": `vxmF2fNK525mqJrGQNB8`,
	"empty": `FK2UXQr1e7uSfjEWzlxZ`,
	"footer": `tBNIbQnnTvTfSALz_wCw`,
	"catalogButton": `XN7SmUuhASiPifPg7w2P`,
	"revealPulse": `fWYXPMMOZNTuE3YgnsO3`,
	"datasetRevealPulse": `boktGfwINNsR0hUJnRwN`
};
export default ___CSS_LOADER_EXPORT___;
